import { render, staticRenderFns } from "./WXBriefingGenerator.vue?vue&type=template&id=0047a114&"
import script from "./WXBriefingGenerator.vue?vue&type=script&setup=true&lang=js&"
export * from "./WXBriefingGenerator.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports